/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
import 'slick-carousel/slick/slick.js';
import 'chosen-js/chosen.jquery.js';
import TypeMate from 'typemate';

export default {
  init() {
    // JavaScript to be fired on all pages

    // smooth scrolling
    $('a.smooth-scroll').on('click', function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
          && location.hostname == this.hostname) {
              var $target = $(this.hash);
              $target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
              if ($target.length) {
                  var targetOffset = $target.offset().top;
                  $('html,body').animate({scrollTop: targetOffset}, 1000);
                  return false;
              }
          }
      });

    // === Hero Panel: Carousel
    var heroCarousel = $('.panel-hero.has-carousel .carousel');
    if (heroCarousel.length) {

      console.log('Found: Hero Panel carousel');

      heroCarousel.on( 'touchend touchcancel touchmove', function() {
        $(this).slick('slickPlay');
      });

      heroCarousel.on('lazyLoaded', function(){
        // alert('carousel images loaded');
      })

      heroCarousel.slick({
        autoplay: true,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: true,
        dots: false,
        draggable: true,
        edgeFriction: 0.15,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 800,
        autoplaySpeed: 5000,
        adaptiveHeight: false,
        fade: true,
        cssEase: 'ease',
        appendArrows: '.panel-hero',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"></button>',
        lazyLoad: 'progressive', // Set lazy loading technique. Accepts 'ondemand' or 'progressive',
      });

    }

    // === Block: Carousel
    var blockCarousel = $('.block-carousel .carousel');
    if (blockCarousel.length) {

      console.log('Found: Block Carousel');

      blockCarousel.on( 'touchend touchcancel touchmove', function() {
        $(this).slick('slickPlay');
      });

      blockCarousel.slick({
        autoplay: true,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: true,
        dots: false,
        draggable: true,
        edgeFriction: 0.15,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 800,
        autoplaySpeed: 5000,
        adaptiveHeight: false,
        fade: false,
        cssEase: 'ease',
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"></button>',
        lazyLoad: 'progressive', // Set lazy loading technique. Accepts 'ondemand' or 'progressive',
      });

    }

    // === Block: Apprentices feed
    // === Block: Success Stories feed
    var mixedCarousel = $('.block-apprentices .carousel, .block-stories .carousel');
    if (mixedCarousel.length) {

      mixedCarousel.each(function(index){
        var
            ParentCarousel = $(this),
            ChildCarousel = ParentCarousel.closest('.mixedCarousel').find('.carousel-child');

        console.log('Found: Apprentices Carousel');
        ParentCarousel.on( 'touchend touchcancel touchmove', function() {
          $(this).slick('slickPlay');
        });
        ParentCarousel.slick({
          asNavFor: ChildCarousel,
          centerMode: true,
          centerPadding: '0',
          autoplay: false,
          infinite: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: true,
          dots: false,
          draggable: true,
          edgeFriction: 0.15,
          slidesToShow: 3,
          slidesToScroll: 1,
          speed: 800,
          autoplaySpeed: 5000,
          adaptiveHeight: false,
          fade: false,
          cssEase: 'ease',
          responsive: [
            {
              breakpoint: 991,
              settings: {
                centerMode: false,
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                centerMode: false,
                slidesToShow: 1,
              },
            },
          ],
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"></button>',
          lazyLoad: 'progressive', // Set lazy loading technique. Accepts 'ondemand' or 'progressive',
        });

        console.log('Found: Apprentices Child Carousel');
        ChildCarousel.on( 'touchend touchcancel touchmove', function() {
          $(this).slick('slickPlay');
        });
        ChildCarousel.slick({
          asNavFor: ParentCarousel,
          // centerMode: false,
          autoplay: false,
          infinite: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: false,
          dots: false,
          draggable: false,
          edgeFriction: 0.15,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 800,
          autoplaySpeed: 5000,
          adaptiveHeight: true,
          fade: true,
          cssEase: 'ease',
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"></button>',
          lazyLoad: 'progressive', // Set lazy loading technique. Accepts 'ondemand' or 'progressive',
        });
      });

      var GotoBtn = mixedCarousel.find('.js-slide-goto');
      if( GotoBtn.length ) {
        GotoBtn.on('click', function(){
          var _this = $(this),
              index = _this.closest('.slide').data('slide');
          console.log('Slide index: ' + index);
          _this.closest('.carousel').slick('slickGoTo', index);
        });
      }

    }

    // === Block: Jobs Feed
    var jobsCarousel = $('.block-jobs .carousel');
    if (jobsCarousel.length) {

      console.log('Found: Block Carousel');

      jobsCarousel.on( 'touchend touchcancel touchmove', function() {
        $(this).slick('slickPlay');
      });

      jobsCarousel.slick({
        autoplay: false,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        centerMode: true,
        centerPadding: '0',
        arrows: true,
        dots: false,
        draggable: true,
        edgeFriction: 0.15,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 800,
        autoplaySpeed: 5000,
        adaptiveHeight: false,
        fade: false,
        cssEase: 'ease',
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              centerPadding: '0',
              dots: true,
              arrows: false,
            },
          },
        ],
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"></button>',
        lazyLoad: 'progressive', // Set lazy loading technique. Accepts 'ondemand' or 'progressive',
      });

    }

    // === Block: Awards Feed
    var awardsCarousel = $('.block-awards .carousel');
    if (awardsCarousel.length) {

      console.log('Found: Block Carousel');

      awardsCarousel.on( 'touchend touchcancel touchmove', function() {
        $(this).slick('slickPlay');
      });

      awardsCarousel.slick({
        autoplay: false,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        dots: true,
        draggable: true,
        edgeFriction: 0.15,
        slidesToShow: 6,
        slidesToScroll: 1,
        speed: 800,
        autoplaySpeed: 5000,
        adaptiveHeight: false,
        fade: false,
        cssEase: 'ease',
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"></button>',
        lazyLoad: 'progressive', // Set lazy loading technique. Accepts 'ondemand' or 'progressive',
      });

    }

    // ===== Boostrap: Tabs
    $('.nav-tabs a').on('click', function(e) {
      e.preventDefault();
      $(this).tab('show');
    });

    // === Blog categories dropdown
    var $blogCatsDropdown = $('.js-blog-cats');
    if( $blogCatsDropdown.length ) {
      $blogCatsDropdown.on('change', function(){
        var val = $(this).val();
        console.log('blog cat change: ' + val);
        if( val ) location.href = val;
      });
    }

    // ===== Suppliers archive
    var suppliersNav = $('.js-suppliers-nav');
    $('.nav-link', suppliersNav).on('click', function(e) {
      var _this = $(this),
          subnav = $(_this.data('subnav'));
      e.preventDefault();
      _this.tab('show');
      if( _this.closest('.suppliers-nav').length ) {
        $('.suppliers-subnavs .nav.active').removeClass('active show').find('.nav-link').removeClass('active');
        if( subnav.length ) {
          $(subnav).addClass('active');
        }
      }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // === Remove widows from general text
    const mainElement = document.getElementById('js-main-wrap');
    const heroElement = document.getElementById('js-panel-hero');
    if( mainElement ) {
      const mainMateInstance = new TypeMate(mainElement, { selector: 'p, h1, h2, h3, h4, h5, h6' });
      mainMateInstance.apply();
    }
    if( heroElement ) {
      const heroMateInstance = new TypeMate(heroElement, { selector: 'p, h1' });
      heroMateInstance.apply();
    }

    var selectElements = $('.wrap select, .panel-hero select');
    if( !$('body').hasClass('no-chosen') && selectElements.length ) {
      console.log('select elements found');
      selectElements.chosen({disable_search_threshold: 999});
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js